import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceImageFetchAction from './machineServiceImageFetch.action.json' with { type: 'json' }
import { machineServiceImageObject } from '../machineServiceImageObject'

const machineServiceImageFetchDefinition = defineAction({
  ...machineServiceImageFetchAction,

  input: z.object({
    machineServiceId: z.string().uuid(),
  }),
  output: z.array(machineServiceImageObject),
})

export default machineServiceImageFetchDefinition
